'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var styled = require('styled-components');
var IconX = require('@narvar/nth-bit-icon-x');
var Button = require('@narvar/nth-block-button');
var NarvarLogo = require('../../../common/components/NarvarLogo.js');
var StylelessButton = require('../../../common/components/StylelessButotn/StylelessButton.js');
var TextLink = require('@narvar/nth-bit-text-link');
var nthHookTheme = require('@narvar/nth-hook-theme');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var nthBitHeader = require('@narvar/nth-bit-header');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var IconX__default = /*#__PURE__*/_interopDefaultLegacy(IconX);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);
var TextLink__default = /*#__PURE__*/_interopDefaultLegacy(TextLink);

const ViewWrapperTopBarContainer = styled__default["default"].div.withConfig({
  componentId: "sc-bp6j9u-0"
})(["display:flex;width:100%;box-sizing:border-box;padding-bottom:1rem;justify-content:space-between};"]);
const ViewWrapperDismissRawButton = _ref => {
  let {
    dismissText,
    ...buttonProps
  } = _ref;
  const {
    claimsCreateClaimDismiss
  } = nthHookTranslations.useTranslations();
  return /*#__PURE__*/React__default["default"].createElement(StylelessButton.StylelessButton, _extends__default["default"]({
    type: Button.ButtonType.button
  }, buttonProps), /*#__PURE__*/React__default["default"].createElement(IconX__default["default"], {
    "aria-label": claimsCreateClaimDismiss ?? dismissText
  }));
};
const ViewWrapperDismissButton = nthHookTranslations.withTranslationsProvider(ViewWrapperDismissRawButton, {
  translationKeys: ['claimsCreateClaimDismiss']
});
const ViewWrapperBackButtonRaw = props => {
  const {
    linksTrackingDefault,
    linksTrackingHover
  } = nthHookTheme.useTheme();
  const {
    claimsButtonBack
  } = nthHookTranslations.useTranslations();
  return /*#__PURE__*/React__default["default"].createElement(TextLink__default["default"], _extends__default["default"]({
    linkStyle: {
      sDefault: linksTrackingDefault,
      sHover: linksTrackingHover
    }
  }, props), claimsButtonBack);
};
const ViewWrapperBackButton = nthHookTheme.withThemeProvider(nthHookTranslations.withTranslationsProvider(ViewWrapperBackButtonRaw, {
  translationKeys: ['claimsButtonBack']
}), {
  themeTokens: ['linksTrackingDefault', 'linksTrackingHover']
});
const ViewWrapperTopBar = _ref2 => {
  let {
    backButton,
    dismissButton
  } = _ref2;
  return /*#__PURE__*/React__default["default"].createElement(ViewWrapperTopBarContainer, null, backButton ? /*#__PURE__*/React__default["default"].createElement(ViewWrapperBackButton, backButton) : /*#__PURE__*/React__default["default"].createElement("div", null), dismissButton ? /*#__PURE__*/React__default["default"].createElement(ViewWrapperDismissButton, dismissButton) : /*#__PURE__*/React__default["default"].createElement("div", null));
};
const ViewWrapperBottomBarRaw = styled__default["default"].div.withConfig({
  componentId: "sc-bp6j9u-1"
})(["display:flex;flex-direction:column;align-items:center;padding-top:1rem;"]);
const ViewWrapperBottomBarRawButton = styled__default["default"].div.withConfig({
  componentId: "sc-bp6j9u-2"
})(["max-width:23rem;width:100%;margin:0 auto;padding-bottom:1rem;"]);
const ViewWrapperBottomBar = _ref3 => {
  let {
    button,
    children
  } = _ref3;
  return /*#__PURE__*/React__default["default"].createElement(ViewWrapperBottomBarRaw, null, children, button && /*#__PURE__*/React__default["default"].createElement(ViewWrapperBottomBarRawButton, null, /*#__PURE__*/React__default["default"].createElement(Button__default["default"], _extends__default["default"]({
    big: true
  }, button))), /*#__PURE__*/React__default["default"].createElement(NarvarLogo["default"], null));
};
const ViewWrapperHeader = _ref4 => {
  let {
    children
  } = _ref4;
  return /*#__PURE__*/React__default["default"].createElement(nthBitHeader.SmallHeader, {
    containerCustomStyle: {
      textAlign: 'center',
      paddingBottom: '1.5rem'
    }
  }, children);
};
const ViewWrapperContent = styled__default["default"].div.withConfig({
  componentId: "sc-bp6j9u-3"
})(["overflow:", ";flex:1 0 0;"], _ref5 => {
  let {
    contentScrollable = true
  } = _ref5;
  return contentScrollable ? 'scroll' : 'visible';
});
const ViewWrapperRoot = styled__default["default"].div.withConfig({
  componentId: "sc-bp6j9u-4"
})(["padding:1.5rem;margin:0 auto;box-sizing:border-box;width:100%;max-width:49.5rem;display:flex;flex-direction:column;height:", ";"], _ref6 => {
  let {
    contentScrollable = true
  } = _ref6;
  return contentScrollable ? '100dvh' : 'visible';
});
const ViewWrapper = _ref7 => {
  let {
    backButton,
    bottomButton,
    dismissButton,
    contentScrollable = true,
    children
  } = _ref7;
  return /*#__PURE__*/React__default["default"].createElement(ViewWrapperRoot, {
    contentScrollable: contentScrollable
  }, /*#__PURE__*/React__default["default"].createElement(ViewWrapperTopBar, {
    backButton: backButton,
    dismissButton: dismissButton
  }), /*#__PURE__*/React__default["default"].createElement(ViewWrapperContent, {
    contentScrollable: contentScrollable
  }, children), /*#__PURE__*/React__default["default"].createElement(ViewWrapperBottomBar, {
    button: bottomButton
  }));
};

exports.ViewWrapperBackButton = ViewWrapperBackButton;
exports.ViewWrapperBottomBar = ViewWrapperBottomBar;
exports.ViewWrapperContent = ViewWrapperContent;
exports.ViewWrapperDismissButton = ViewWrapperDismissButton;
exports.ViewWrapperDismissRawButton = ViewWrapperDismissRawButton;
exports.ViewWrapperHeader = ViewWrapperHeader;
exports.ViewWrapperRoot = ViewWrapperRoot;
exports.ViewWrapperTopBar = ViewWrapperTopBar;
exports.ViewWrapperTopBarContainer = ViewWrapperTopBarContainer;
exports["default"] = ViewWrapper;
